import React, { useEffect, useState } from "react";
import { Col, Empty, Row, Spin, Typography } from "antd";
import { StyledBlogs } from "./styles";
import FooterSection from "../Landing/FooterSection";
import TopBar from "../Landing/Topbar";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constant/routes";
import httpClient from "../../../api/httpClient";
import { FILE_BASE_URL } from "../../../config";

const Blogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        setLoading(true);

        const { data } = await httpClient.publicGet("blogs");

        setBlogs(data);
      } catch (error) {
        console.error("Failed to fetch blogs:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchBlogs();
  }, []);

  const navigate = useNavigate();
  return (
    <StyledBlogs>
      <TopBar />
      <div className="blogs">
        <Typography.Title level={2} className="page-title">
          Kelu Ai Blogs
        </Typography.Title>

        {loading ? (
          <div className="flex-center loading">
            <Spin />
          </div>
        ) : !!blogs.length ? (
          <Row gutter={[24, 24]}>
            {blogs.map((blog, index) => (
              <Col
                xs={24}
                sm={12}
                lg={8}
                key={index}
                onClick={() => navigate(`${ROUTES.BLOGS}/${blog.id}`)}
              >
                <div className="blog-card">
                  <img
                    src={`${FILE_BASE_URL}${blog.image}`}
                    alt={blog.title}
                    className="blog-image"
                  />
                  <h2 className="blog-title">{blog.title}</h2>
                </div>
              </Col>
            ))}
          </Row>
        ) : (
          <div className="flex-center not-found">
            <Empty description="Blogs not found" />
          </div>
        )}
      </div>

      <FooterSection />
    </StyledBlogs>
  );
};

export default Blogs;
